<template>
  <div id="services" class="bg-secondary-50">

    <div class="pt-24 pb-20 container-xwide mx-auto">
      <h6 class="text-secondary-500">
        —  Fertility Tests
      </h6>

      <h2 class="mt-2 max-w-screen-sm">
        First Options Fertility offers a range of advanced testing options to further examine your fertility status.
      </h2>

      <div class="grid sm:grid-cols-1 lg:grid-cols-3 gap-4 mt-10">

        <div class="product-card rounded-md p-5">
          <div class="flex items-baseline justify-between">
            <p class="font-bold text-xl">
              SOS Test (Semen Oxidative Stress Test).
            </p>
          </div>

          <p class="text-gray-700 mt-4">
            The SOS test provides a comprehensive measure of stress in semen. Oxidative stress can cause sperm damage. If there is an imbalance in antioxidant capacity in semen this could in turn be impacting your semen quality and fertility. Our test is a quick indicator of whether further, more complex testing is necessary.
          </p>

          <p class="mt-4 text-gray-900 font-medium">
            SOS is an ideal test to combine with a standard semen assessment to get the most comprehensive first sperm test for couples investigating fertility issues.
          </p>

          <p class="text-gray-700 mt-4">
            This test can be done at the same time as a standard semen assessment. Results are returned the same day enabling an efficient, cost-effective, thorough semen examination.
          </p>
        </div>

        <div class="product-card rounded-md p-5">
          <div class="flex items-baseline justify-between">
            <p class="font-bold text-xl">
              DNA fragmentation tests / DNA integrity tests
            </p>
          </div>

          <p class="text-gray-700 mt-4">
            Sperm DNA can be damaged when sperm are being made in the testes or as they mature before ejaculation. Knowing if you have sperm DNA damage can help you make informed decisions about medical treatments and lifestyle changes to improve the quality of your sperm DNA. It is known that men with high levels of sperm DNA damage are less likely to get their partner pregnant and have increased risk of miscarriage. DNA fragmentation testing can help diagnose couples previously faced with ‘unexplained infertility’. Also, the test can highlight a potential reason for recurrent miscarriages
          </p>
          <p class="text-gray-700 mt-4">
            First Options Fertility partners with two distinguished testing laboratories to offer clinicians and patients choice in the DNA testing they require.
          </p>

          <ul class="mt-6 grid gap-2 grid-cols-2">
            <li class="border-gray-200 border rounded p-2">
              <a href="https://examenlab.com/" target="_blank">
                <div class="image-container">
                  <img src="@/assets/images/ExamenLabs.jpg" alt="First Options Fertility - located in Gorey, Co. Wexford"/>
                </div>
              </a>
            </li>
            <li class="border-gray-200 border rounded p-2">
              <a href="https://www.spzlab.com/en/" target="_blank">
                <div class="image-container">
                  <img src="@/assets/images/SPZLab.jpg" alt="First Options Fertility - located in Gorey, Co. Wexford"/>
                </div>
              </a>
            </li>
          </ul>
        </div>

        <div class="product-card rounded-md p-5">
          <div class="flex items-baseline justify-between">
            <p class="font-bold text-xl">
              Semen culture and sensitivity
            </p>
          </div>

          <p class="text-gray-700 mt-4">
          Semen culture test is the laboratory test, which is done to check for presence of microorganisms in the semen. Depending on the nature of the infection, testicular sperm production, sperm transport, and sperm function can be compromised. A semen sample is cultured in a growth media and the microbe/bacterium present in the semen culture is identified. This test will help doctors understand the correct antibiotic that can be given to a patient to treat an infection.
          </p>

        </div>

      </div>



    </div>
  </div>
</template>

<script>

export default {
  name: 'StarterServices',
  components: {
  },
}
</script>

<style scoped>
.product-card  {
  @apply bg-white;
}

.rounded-full {
  @apply bg-gray-100;
}
</style>
